import httpRequest from "@/services/httpRequest"
import quranData from '@/assets/json/quran_metadata.json'
import { create } from "qrcode"
import id from "dayjs/locale/id"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    classRooms: [],
    classRoom: null,
    studentClassRooms: [],
    students: [],
    student: null,
    studentStats: {},
    tilawahStudentClassRooms: [],
    search: '',
    searchMember: '',
    searchAddMember: '',
    page: 1,
    pageMember: 1,
    pageAddMember: 1,
    rows: 20,
    filter: '',
    tilawahs: [],
    tilawah: null,
    surahs: [],
    classroomEvaluation: [],
    studentClassroomEvaluation: [],
    studentEvaluation: [],
  },
  mutations: {
    SET_STUDENT_CLASSROOMS(state, data) {
      state.studentClassRooms = data
    },
    SET_STUDENT_FIRST(state, data) {
      state.students = data
    },
    SET_STUDENT(state, data) {
      data.forEach((student) => {
        state.students.push(student)
      })
    },
    SET_CLASSROOMS_FIRST(state, data) {
      state.classRooms = data
    },
    SET_CLASSROOMS(state, data) {
      data.forEach((classRoom) => {
        state.classRooms.push(classRoom)
      })
    },
    SET_CLASSROOM(state, data) {
      state.classRoom = data
    },
    DELETE_CLASSROOM(state, id) {
      state.classRooms = state.classRooms.filter(item => item.id !== id)
    },
    UPDATE_CLASSROOM(state, data) {
      const index = state.classRooms.findIndex(item => item.id === data.id)
      if (index !== -1) {
        state.classRooms.splice(index, 1, data)
      }

      state.classRoom = data
    },
    SET_TILAWAH_STUDENT_CLASSROOMS_FIRST(state, data) {
      state.tilawahStudentClassRooms = data
    },
    SET_TILAWAH_STUDENT_CLASSROOMS(state, data) {
      data.forEach((student) => {
        state.tilawahStudentClassRooms.push(student)
      })
    },
    DELETE_MEMBER(state, id) {
      //console.log(state.tilawahStudentClassRooms)
      state.tilawahStudentClassRooms = state.tilawahStudentClassRooms.filter(item => item.id !== id)
    },
    SET_TILAWAH_STUDENT_CLASSROOM(state, data) {
      state.student = data
    },
    SET_TILAWAHS(state, data) {
      state.tilawahs = data
    },
    SET_TILAWAH(state, data) {
      state.tilawah = data
    }
  },
  actions: {
    async getStudentClassRoom({ rootState, state, commit }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/classroom?rows=100&level__isnull=false`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_STUDENT_CLASSROOMS', res.data.results)
      }
    },

    async getStudent({ rootState, state, commit }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/student?query={id,name,photo,classroom}&page=${state.pageAddMember}&rows=${state.rows}&search=${state.searchAddMember}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (status === 'first') {
          commit('SET_STUDENT_FIRST', res.data.results)
        } else {
          commit('SET_STUDENT', res.data.results)
        }
      }
    },

    async getClassRooms({rootState, state, commit}, type) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_classroom?rows=${state.rows}&page=${state.page}&search=${state.search}${state.filter}`,
            method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      if (res.status === 200) {
        if (type === 'first') {
          commit('SET_CLASSROOMS_FIRST', res.data.results)
        } else {
          commit('SET_CLASSROOMS', res.data.results)
        }
        state.isLoading = false
      } else {
        state.isLoading = false
      }
    },

    async getClassRoom({rootState, commit}, id) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_classroom/${id}`,
            method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_CLASSROOM', res.data)
      }

      
      return res
    },

    async createClassRoom({rootState}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_classroom`,
            method: 'POST',
            data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      return res
    },

    async editClassRoom({ rootState }, {id, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async deleteClassRoom({rootState, commit}, id) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_classroom/${id}`,
            method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 204) {
        commit('DELETE_CLASSROOM', id)
      }
      
      return res
    },

    async updateClassRoom({rootState, commit, state}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_classroom/${state.classRoom.id}`,
            method: 'PUT',
            data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('UPDATE_CLASSROOM', res.data)
      }
      
      return res
    },

    async getTilawahStudentClassRooms({rootState, commit, state}, status) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_student_classroom?classroom=${state.classRoom.id}&page=${state.pageMember}&rows=${state.rows}&search=${state.searchMember}`,
            method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (status === 'first') {
          commit('SET_TILAWAH_STUDENT_CLASSROOMS_FIRST', res.data.results)
        } else {
          commit('SET_TILAWAH_STUDENT_CLASSROOMS', res.data.results)
        }
      }
    },

    async getTilawahStudentClassRoom({rootState, commit, state}, id) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_student_classroom/${id}`,
            method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_TILAWAH_STUDENT_CLASSROOM', res.data)
      }

      return res
    },

    async tilawahClassRoomDo({rootState, commit, state}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_classroom/${data.id}/do`,
            method: 'POST',
            data: data.data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async removeMember({rootState, commit}, id) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_student_classroom/${id}`,
            method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 204) {
        commit('DELETE_MEMBER', id)
      }
      
      return res
    },

    async addTilawahStudentClassRoom({rootState, commit}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah_student_classroom`,
            method: 'POST',
            data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      return res
    },

    async getTilawahs({rootState, commit}, id) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah?real_student=${id}`,
            method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      if (res.status = 200) {
        commit('SET_TILAWAHS', res.data.results)
      }
      
      return res
    },
    
    async getSurahs({state}) {
      let rawSurahs = [...quranData.surahs]
      rawSurahs.forEach((surah, index) => {
        state.surahs.push({
          surahNumber: index + 1,
          label: surah.surahName,
          value: surah.surahName,
          ayah: surah.totalAyah,
          level: 'QURAN'
        })
      })
    },

    async addTilawah({rootState}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah`,
            method: 'POST',
            data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      return res
    },

    async deleteTilawah({rootState,state}, id) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah/${id}`,
            method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 204) {
        state.tilawahs = state.tilawahs.filter(item => item.id !== id)
      }
      
      return res
    },

    async getTilawah({rootState, commit}, id) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah/${id}`,
            method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      if (res.status = 200) {
        commit('SET_TILAWAH', res.data)
      }
      
      return res
    },

    async updateTilawah({rootState, state}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah/${state.tilawah.id}/retake`,
            method: 'POST',
            data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      if (res.status = 200) {
        state.tilawahs.unshift(res.data)
      }
      
      return res
    },

    async updateTilawahItem({rootState, state}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/tilawah/${state.tilawah.id}`,
            method: 'PATCH',
            data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      if (res.status = 200) {
      }
      
      return res
    },

    async getStudentStats({ rootState, state }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_student_classroom/${id}/stats`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.studentStats = res.data
      }
      return res
    },

    async getClassroomEvaluation({ rootState, state }, param) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom_evaluation`,
          method: 'GET',
          params: param
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.classroomEvaluation = res.data.results
      }

      return res
    },
    
    async addClassroomEvaluation({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom_evaluation`,
          method: 'POST',
          data: data
        },
        authorized: true
      }
      
      const res = await httpRequest(payload)
      
      return res
    },

    async editClassroomEvaluation({ rootState }, {id, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom_evaluation/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async deleteClassroomEvaluation({ rootState }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom_evaluation/${id}`,
          method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async getStudentClassroomEvaluation({ rootState, state }, param) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_student_classroom_evaluation`,
          method: 'GET',
          params: param
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.studentClassroomEvaluation = res.data.results
      }

      return res
    },

    async getStudentEvaluation({ rootState, state }, param) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom/get_student_evaluations_by_semester`,
          method: 'GET',
          params: param
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.studentEvaluation = res.data.tilawah_evaluations
      }

      return res
    },

    async updateStudentGrade({ rootState }, {id, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_student_classroom_evaluation/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }
      
      const res = await httpRequest(payload)
      
      return res
    },
  }
})